import React, { PureComponent } from 'react';

import { Dialog } from '../../base/dialog';
import { translate } from '../../base/i18n';
import { connect } from '../../base/redux';
import { disableLobbySound } from '../actions.web';

type Props = {
    disabledLobbySound: boolean,
    dispatch: Function,
    t: Function
};

type State = {
    applyToAllModerators: boolean
};

const styles = {
    helperText: {
        marginBottom: 12
    },
    scopeLabel: {
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        gap: 8
    }
};

/**
 * Dialog used to choose lobby sound preference scope before applying it.
 */
class LobbySoundScopeDialog extends PureComponent<Props, State> {
    /**
     * Initializes a new LobbySoundScopeDialog instance.
     *
     * @param {Props} props - Component props.
     */
    constructor(props: Props) {
        super(props);

        this.state = {
            applyToAllModerators: false
        };

        this._onScopeChange = this._onScopeChange.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
    }

    /**
     * Implements React's render.
     *
     * @returns {React$Node}
     */
    render() {
        const { disabledLobbySound, t } = this.props;
        const { applyToAllModerators } = this.state;
        const actionText = disabledLobbySound ? t('lobby.unMuteLobbySound') : t('lobby.muteLobbySound');

        return (
            <Dialog
                cancelKey = 'dialog.Cancel'
                okKey = 'dialog.Ok'
                onSubmit = { this._onSubmit }
                titleString = { actionText }
                width = 'small'>
                <div>
                    <div style = { styles.helperText }>
                        { t('lobby.soundScopeDialogDescription') }
                    </div>
                    <label
                        htmlFor = 'lobby-sound-apply-all-moderators'
                        style = { styles.scopeLabel }>
                        <input
                            checked = { applyToAllModerators }
                            id = 'lobby-sound-apply-all-moderators'
                            onChange = { this._onScopeChange }
                            type = 'checkbox' />
                        <span>{ t('lobby.soundScopeApplyAllModerators') }</span>
                    </label>
                </div>
            </Dialog>
        );
    }

    _onScopeChange: (SyntheticInputEvent<HTMLInputElement>) => void;

    /**
     * Updates broadcast scope based on checkbox state.
     *
     * @param {Object} event - Checkbox change event.
     * @returns {void}
     */
    _onScopeChange(event) {
        this.setState({
            applyToAllModerators: Boolean(event?.target?.checked)
        });
    }

    _onSubmit: () => boolean;

    /**
     * Applies lobby sound preference after scope confirmation.
     *
     * @returns {boolean}
     */
    _onSubmit() {
        const { disabledLobbySound, dispatch } = this.props;
        const { applyToAllModerators } = this.state;

        dispatch(disableLobbySound(!disabledLobbySound, {
            broadcast: applyToAllModerators
        }));

        return true;
    }
}

/**
 * Maps lobby sound state to dialog props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        disabledLobbySound: Boolean(state['features/lobby']?.disabledLobbySound)
    };
}

export default translate(connect(mapStateToProps)(LobbySoundScopeDialog));
